import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { CircularProgress, Box } from '@mui/material'
import { useAuthStore } from '../stores/authStore'
import { useSessionMonitor } from '../hooks/useSessionMonitor'

export default function ProtectedRoute() {
  const { isAuthenticated, hydrated, requires2FA, requiresEnrollment } = useAuthStore()
  const location = useLocation()

  useSessionMonitor()

  if (!hydrated) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    )
  }

  if (!isAuthenticated && (requires2FA || requiresEnrollment)) {
    return <Navigate to="/login" state={{ from: location, twoFA: true }} replace />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <Outlet />
}